import { createContext } from 'react';

import { BusinessContextType, Nullable } from '@/types';

export const BusinessDataContext = createContext<Nullable<BusinessContextType>>(null);
